'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './will-sub-for.routes';

export class WillSubForComponent {
  constructor(Config, Auth, User, dialogs) {
    'ngInject';

    this.Auth = Auth;
    this.User = User;
    this.dialogs = dialogs;
    this.groups = Config.getModuleConfig(Config.Modules.General).getGroups();
    this.selectedGroups = {};

    this.user = Auth.getCurrentUserSync();
    if (this.user.willSubFor) {
      this.user.willSubFor.forEach(groupKey => {
        this.selectedGroups[groupKey] = true;
      });
    }
  }

  save() {
    let groups = this.groups.filter(group => this.selectedGroups[group.key]).map(group => group.key);

    this.user.willSubFor = groups;
    this.Auth.updateUser(this.user);

    this.dialogs.notify("Success", "The changes have been saved.");
  }
}

export default angular.module('conduuApp.willSubFor', [uiRouter])
  .config(routes)
  .component('willSubFor', {
    template: require('./will-sub-for.html'),
    controller: WillSubForComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/will-sub-for/will-sub-for.component.js